import * as React from 'react';
import axios from 'axios';
import {isFichierAttenteValidation, renderAlert, renderFilArianne, renderInput, renderTitleH1} from './RenderCommon';
import { RenderContentFiles } from './RenderContentFiles';
import Modal from 'react-responsive-modal';
import 'moment/locale/fr';

// @ts-ignore
import ReactTooltip from 'react-tooltip';
import {
  getAuthorizedFilesExtension,
  getBoutiqueColor,
  getCompetences,
  getUserId,
  sessionExpire
}
  from './MonCompteAction';
  import {
    validationVisuel,
    conformiteVisuel
  } from './iMonCompte';
import { formatDate, formatNumCommande } from './OrderAction';
import Icons from './Icons';
import {getFeatureEnabledPostprocessing, getHostApi, getRequestConfig, scrollTo} from '../../utils';
import RenderCountdown from "./RenderCountdown";
import moment from "moment";
import {getShopInfosInStorage} from "../cart/ShopInfos";
import {SwitchBtn} from "./SwitchBtn";
import {DevaliderFichiersClient} from "./upload/components/DevaliderFichiersClient";

//eslint-disable-next-line
declare var window: any;
export const initialState = (props:any) => {
  return {
    nbPanachages: [],
    showAlert: false,
    textAlert: '',
    classAlert: '',
    open: false,
    openComment: false,
    openPanachage: false,
    openBAT: false,
    checkbox: '0',
    checkboxComment: '0',
    checkboxPanachage: '0',
    activatePanachage: false,
    activatePanachageQuadriluxe: false,
    activatePanachageSublimation: false,
    activatePanachageBroderie: false,
    activatePanachageSericoat: false,
    activatePanachageTopQuadri: false,
    activateCheckImageUsage: false,
    selectPanachage: false,
    showTelephoneProblemeTechnique: false,
    showActivatePanachage: false,
    authorizedFiles: [],
    telephoneProblemeTechique: '',
    selectedOrderId: props.match.params.id ? props.match.params.id : null,
    validation_bat: '0',
    commentaire: '',
    operateur: null,
    isBatAuto: false,
    isBatAutoBroderie: false,
    contourCustom: false,
    customerChoixBroderie: false,
    isInternalUser: false,
    setValidationBatAutoClicked: false,
    displayMessageBatAutoOK: false,
    userInternId: null,
    commentaireBAT: null,
    customerView: false,
    showCommentaireBat: false,
    showTracabilite: false,
    openDevaliderFichiers: false,
    dataNonConforme: [],
    aucunNonConforme: true,
    openNonConforme: false,
    needToValidate: false,
    showMoreOptions: false,
    hasClientFiles: false,
    enabledPostProcessing: false
  }
};

export default class RenderFiles extends React.Component<any, any> {

  private _isMounted: boolean;
  constructor(props: any) {
    super(props);
    this._isMounted = false;
    this.state = initialState(props) ;
  }

  reset() {
    this.setState(initialState(this.props));
  }

  componentDidMount(): void {
    this._getOrders();
    this._getActivationPanachage();
    this._getActivationPanachageQuadriluxe();
    this._getActivationPanachageSublimation();
    this._getActivationPanachageBroderie();
    this._getActivationPanachageSericoat();
    this._getActivationPanachageTopQuadri();
    this._getActivationCheckImageUsage();
    this._getHasClientFiles();
    this._affectCanGallerie();
    this._canCustomDimensionsBatAuto();
    this._fetchVariableMontantSansControleBATAuto();
    this._showTelephoneProblemeTechique();
    this._getTelephoneProblemeTechique();
    this._getOperateur();
    this._isMounted = true;
    getFeatureEnabledPostprocessing()
      .then(response => this.setState({ enabledPostProcessing: response.data?.feature ?? false}));
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.reset();
  }

  _getCompetences() {
    if(this.state.operateur && this.state.operateur.id) {
      getCompetences().then((competences: number[]) => {
        const droitsUser = {userInternId : this.state.operateur.id, isInternalUser: false, isInternalUserAdmin: false };
        if (competences && competences.includes(18)) {
          Object.assign(droitsUser, {isInternalUser: true});
          if (competences && competences.includes(19)) {
            Object.assign(droitsUser, {isInternalUserAdmin: true});
          }
          if (competences && competences.includes(20)) {
            Object.assign(droitsUser, {canUpdateFichierDestructure: true});
          }
          if (competences && competences.includes(23)) {
            Object.assign(droitsUser, {canUploadFichierDT: true});
          }
          if (competences && competences.includes(24)) {
            Object.assign(droitsUser, {canUpdateCmjn: true});
          }
          if (competences && competences.includes(25)) {
            Object.assign(droitsUser, {canUpdateOutlineProcessing: true});
          }
          if (competences && competences.includes(41)) {
            Object.assign(droitsUser, {canCheckImageUsage: true});
          }
          if (competences && competences.includes(58)) {
            Object.assign(droitsUser, {canDownloadEmbroidery: true});
          }
        }
        this.setState(droitsUser);
      })
    }
  }

  _getOperateur() {
    axios.get(`${getHostApi()}/customers/${getUserId()}`, getRequestConfig())
      .then((response) => {
        if (response.data.customer) {
          this.setState({
            operateur: response.data.customer.operateur,
          }, () => this._getCompetences())}
      }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  _fetchLogs() {
    if(this.state.isInternalUser && this.state.isBatAuto) {
      axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${this.state.selectedOrderId}/commentaires-fabrication`, getRequestConfig()).then((response) => {
        if (response.data.commentairesFabrication) {
          this.setState({ commentairesFabrication: response.data.commentairesFabrication });
        }
      }).catch((error) => {
        if (error.response.status === 401) { sessionExpire(); }
      });
    }
  }

  _fetchCommentaireBat() {
    if(this.state.order && this.state.order.commentaireBAT && this.state.order.commentaireBAT !== '') {
      this.setState({commentaireBAT : this.state.order.commentaireBAT, showCommentaireBat: true });
    }
  }

  _getOrders() {
    axios.get(`${getHostApi()}/customers/${getUserId()}/orders/`, {
      ...getRequestConfig(),
      params: { diff_StatutCommande: 9 },
    }).then((response) => {
      if (response.data.orders) {
        this.setState({ orders: response.data.orders }, () => { this._defineSelectedOrder(); });
      }
    }).catch((error) => {
      if (error.response.status === 401) { sessionExpire(); }
    });
  }

  _getOrder() {
    if(this.state.selectedOrderId) {
      this._fetchActivationBatAuto();
    }

    axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${this.state.selectedOrderId}`, getRequestConfig()).then((response) => {
      if (response.data.order) {
        this.setState({ order: response.data.order }, () => {
          this._getNbPanachages();
          this._getMarquages();
          this._fetchLogs();
          this._fetchCommentaireBat();
          if(this.state.order.sav == "1") {
            this._getDevaliderFichiers();
          }
        });

        const elt: any = document.getElementById('envoiFichierOK');
        if(elt != null) {
          window.scrollTo(elt, 'top');
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  _getHasClientFiles() {
    axios.get(`${getHostApi()}/customers/${getUserId()}/has-files`,
      getRequestConfig()).then((response) => {
      if (response.data.hasFiles) {
        this.setState({ hasClientFiles: response.data.hasFiles });
      }
    }).catch((error) => { if (error.response.status === 401) { sessionExpire(); } });
  }


  _canCustomDimensionsBatAuto = () => {
    axios.get(`${getHostApi()}/shops/features/bat_auto_dimensions_client`,
      getRequestConfig(),
    ).then((response) => {
      if (response.data) { this.setState({ canCustomDimensionsBatAuto: response.data.feature }); }
    }).catch((error) => { if (error.response.status === 401) { sessionExpire(); } });
  }

  _getActivationPanachage = () => {
    axios.get(`${getHostApi()}/shops/features/compte_panachage`,
      getRequestConfig()).then((response) => {
      if (response.data.feature) { this.setState({ activatePanachage: response.data.feature }); }
    }).catch((error) => {
      if (error.response.status === 401) { sessionExpire(); }
    });
  }

  _getShowActivatePanachage = () => {
    this.setState({ showActivatePanachage: false });
    if (this.state.marquages && !this.state.showActivatePanachage) {
      for (const item of this.state.marquages) {
        if (item.nom.indexOf('pf_') === -1) {
          axios.get(`${getHostApi()}/shops/features/compte_panachage_${item.libelle.toLowerCase()}`,
            getRequestConfig(),
          ).then((response) => {
            if (response.data.feature) { this.setState({ showActivatePanachage: true }); }
          }).catch((error) => { console.log(error); });
        }
      }
    }
  }

  _getMarquages() {
    axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${this.state.order.idCommande}/techniques-marquage`,
      getRequestConfig())
      .then((response) => {
        if (response.data.techniquesMarquage) {
          this.setState({ marquages: response.data.techniquesMarquage });
          this._getShowActivatePanachage();
        }
      }).catch((error) => {
      if (error.response && error.response.status === 401) { sessionExpire(); }
    });
  }

  _getActivationPanachageQuadriluxe = () => {
    axios.get(`${getHostApi()}/shops/features/compte_panachage_quadriluxe`,
      getRequestConfig()).then((response) => {
      if (response.data.feature) { this.setState({ activatePanachageQuadriluxe: response.data.feature }); }
    }).catch((error) => { if (error.response.status === 401) { sessionExpire(); } });
  }

  _getActivationPanachageSublimation = () => {
    axios.get(`${getHostApi()}/shops/features/compte_panachage_sublimation`,
      getRequestConfig()).then((response) => {
      if (response.data.feature) { this.setState({ activatePanachageSublimation: response.data.feature }); }
    }).catch((error) => { if (error.response.status === 401) { sessionExpire(); } });
  }

  _getActivationPanachageBroderie = () => {
    axios.get(`${getHostApi()}/shops/features/compte_panachage_broderie`,
      getRequestConfig()).then((response) => {
      if (response.data.feature) { this.setState({ activatePanachageBroderie: response.data.feature }); }
    }).catch((error) => { if (error.response.status === 401) { sessionExpire(); } });
  }

  _getActivationPanachageSericoat = () => {
    axios.get(`${getHostApi()}/shops/features/compte_panachage_sericoat`,
      getRequestConfig()).then((response) => {
      if (response.data.feature) { this.setState({ activatePanachageSericoat: response.data.feature }); }
    }).catch((error) => { if (error.response.status === 401) { sessionExpire(); } });
  }

  _getActivationPanachageTopQuadri = () => {
    axios.get(`${getHostApi()}/shops/features/compte_panachage_topquadri`,
      getRequestConfig()).then((response) => {
      if (response.data.feature) { this.setState({ activatePanachageTopQuadri: response.data.feature }); }
    }).catch((error) => { if (error.response.status === 401) { sessionExpire(); } });
  }
  
  _getActivationCheckImageUsage = () => {
    axios.get(`${getHostApi()}/shops/features/check_image_usage`,
      getRequestConfig()).then((response) => {
      if (response.data.feature) { this.setState({ activateCheckImageUsage: response.data.feature }); }
    }).catch((error) => { if (error.response.status === 401) { sessionExpire(); } });
  }

  _getNbPanachages = () => {
    axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${this.state.order.idCommande}/nb-panachages`,
      getRequestConfig(),
    ).then((response) => {
      this.setState({ nbPanachages: response.data.nbPanachages });
      if (this.state.nbPanachages.length > 0) {
        Array.from(this.state.nbPanachages).forEach((element: any) => {
          if (element.nbPanachages && element.nbPanachages != '0' ) {
            this.setState({ selectPanachage: true, checkboxPanachage: '1', showMoreOptions: true});
          }
        });
      } else if(this.state.showMoreOptions) {
        this.setState({ showMoreOptions: !this.state.showMoreOptions});
      }
    }).catch((error) => { console.log('error'); });
  }

  _fetchActivationBatAuto = () => {
    axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${this.state.selectedOrderId}/bat-auto`,
      getRequestConfig()).then((response) => {
      if (response.data) {
        this.setState({ isBatAuto : response.data.isBatAuto, isBatAutoBroderie: response.data.isBatAutoBroderie, contourCustom: response.data.contourCustom,
          customerChoixBroderie: response.data.customerChoixBroderie }, () => {
          this._fetchStatutVisuels();
        });
      }
      getAuthorizedFilesExtension(this.state.isBatAuto).then((authorizedFiles: string[]) => {
        this.setState({ authorizedFiles: authorizedFiles, });
      });
    }).catch((error) => {
      if (error.response.status === 401) { sessionExpire(); }
    });
  }

  _onOrderUpdated = () => { this._getOrder(); }

  _onCanValidate = (canValidate: boolean) => { this.setState({ canValidate: canValidate }, () => { if(this.state.isBatAuto) { this._fetchStatutVisuels(); }}); }

  _defineSelectedOrder = () => {
    let orderId = this.state.selectedOrderId;
    if (!orderId && this.state.orders.length > 0 && !this.state.orders[0].AucunMarquage) {
      orderId = this.state.orders[0].idCommande;
    }
    if(!orderId && (getShopInfosInStorage().Ref === 'DT')) {
      for (const order of this.state.orders) {
        if (order.cf != '1' && !order.AucunMarquage) {
          orderId = order.idCommande
          break;
        }
      }
    }
    this.setState({ selectedOrderId: orderId }, () => { this._getOrder();});

    return orderId;
  }

  _onChangeOrderSelected = (event: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ selectedOrderId: event.target.value, needToValidate: false }, () => {
      this._onOrderUpdated();
      let url = '/www/MonCompte/moncompte.php/files/';
      if (getShopInfosInStorage().Ref === 'DT'){
        url = '/mon-compte#/files/';
      } else if(getShopInfosInStorage().Ref === 'TH') {
        url = '/account/files/';
      }
      window.history.pushState('', '', url + this.state.selectedOrderId);
    });
  }

  _lancerFabrication = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    axios.put(`${getHostApi()}/customers/${getUserId()}/orders/${this.state.order.idCommande}/manufacturing`,
      { commentaire: this.state.commentaire, confirmationFichier: '1', dates: { dateDepart: this.state.order.DateDepart, dateLivraison: this.state.order.date_livraison_prevue }, isBatAuto: this.state.isBatAuto},
      getRequestConfig()).then((response) => {
      this.onCloseModal();
      this._getOrder();
      this.setState({
        needToValidate: false,
        openModalLancerFabrication: false
      });
    }).catch((error) => {
      this.setState({
        showAlert: true,
        textAlert: 'Une erreur est survenue pendant l\'envoi de vos fichiers',
        classAlert: 'alert-danger',
        open: false,
        openComment: false,
        openPanachage: false,
      });
    });
  }

  _devaliderFichier = (event: React.MouseEvent<HTMLButtonElement>, isByClient: boolean = false) => {
    event.preventDefault();
    axios.put(`${getHostApi()}/customers/${getUserId()}/orders/${this.state.order.idCommande}/fichiers`,
      { value: 0, isByClient: isByClient},
      getRequestConfig()).then((response) => {
        if(isByClient) {
          const succes = response.data.success;
          this.setState({
            classAlert: 'alert-danger',
            textDevaliderFichierByClient: response.data.message
          });
          this.onCloseModalDevaliderFichiersByClient();
          if(succes) {
            this._getOrder();
            this.setState({
              classAlert: 'alert-success',
              textDevaliderFichierByClient: ''
            });
          }
        } else {
          this.onCloseModalDevaliderFichiers();
          this._getOrder();
          this.setState({
            showAlert: true,
            textAlert: response.data.message,
            classAlert: 'alert-success'
          });
        }
    }).catch(() => {
      this.setState({
        showAlert: true,
        textAlert: 'Une erreur est survenue pendant la dévalidation des fichiers',
        classAlert: 'alert-danger',
        openDevaliderFichiers: false,
        openDevaliderFichiersByClient: false,
      });
    });
  }

  _getDevaliderFichiers = () => {
    axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${this.state.order.idCommande}/fichiers`,
      getRequestConfig()).then((response) => {
      if (response.data) { this.setState({ cmdPrincipale: response.data.CmdPrincipale, lienOldCmd: response.data.lien }); }
    }).catch((error) => { if (error.response.status === 401) { sessionExpire(); } });
  }

  _showTelephoneProblemeTechique = () => {
    axios.get(getHostApi() + '/shops/features/compte_upload_affichage_telephone',
      getRequestConfig(),
    ).then((response) => {
      this.setState({ showTelephoneProblemeTechnique: response.data.feature });
    }).catch((error) => {
      console.log(error);
      if (error.response && error.response.status && error.response.status === 401) { sessionExpire(); }
    });
  }

  _getTelephoneProblemeTechique = () => {
    axios.get(getHostApi() + '/shops/variables/compte_upload_numero_telephone', getRequestConfig()).then((response) => {
      if (response.data.variable) {
        this.setState({ telephoneProblemeTechique: response.data.variable['valeur'] });
      }
    }).catch((error) => { if (error.response.status === 401) { sessionExpire(); } });
  }

  _onUpdateInput = (event: React.ChangeEvent<HTMLInputElement>, isModal: boolean = false) => {
    const target = event.target;
    const value = (target.checked) ? '1' : '0';

    if (target.type == 'checkbox' && target.name == 'droits') {
      const droits = document.getElementById('formDroits');
      const formDroitsModal = document.getElementById('formDroitsModal');
      if (droits && target.checked && target.name == 'droits') {
        droits.classList.remove('alert', 'alert-danger');
      }
      if (formDroitsModal && target.checked && target.name == 'droits') {
        formDroitsModal.classList.remove('alert', 'alert-danger');
      }
      this.setState({checkbox: value});

    } else if (target.type == 'checkbox' && target.name == 'commentModal' && isModal) {
      const comments: any = document.getElementById('commentaireClientFilesModal');
      const commentArea: any = document.getElementById('commentaireClientModal');
      if (comments && target.checked && target.name == 'commentModal') {
        this.setState({ openComment: true });
      } else {
        this.setState({ commentaire: '' });
        commentArea.value = '';
        this.showComment(isModal);
      }
      this.setState({ checkboxComment: value });
    } else if (target.type == 'checkbox' && target.name == 'comment') {
      const comments: any = document.getElementById('commentaireClientFiles');
      const commentArea: any = document.getElementById('commentaireClient');
      if (comments && target.checked && target.name == 'comment') {
        this.setState({ openComment: true });
      } else {
        this.setState({ commentaire: '' });
        commentArea.value = '';
        this.showComment();
      }
      this.setState({ checkboxComment: value });
    } else if (target.type == 'checkbox' && target.name == 'activatePanachage') {
      if (target.checked) {
        this.setState({ openPanachage: true, showMoreOptions: true });
      } else {
        this.setState({ checkboxPanachage: '0', openPanachage: false, selectPanachage: false });
      }
    }
  }

  _resetAlert = () => {
    if (this.state.textAlert != '') {
      this.setState({
        textAlert: '',
        classAlert: '',
        showAlert: false,
      });
    }
  }

  showCommentaireBAT = () => {
    this.setState({ showCommentaireBat: !this.state.showCommentaireBat });
  }

  onCloseBAT = () => {
    this.setState({ openBAT: false });
  }
  onOpenBAT = () => {
    this.setState({ openBAT: true });
  }

  setCommentaireBAT = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newComment =   event.target.value == '' ? null :   event.target.value;
    this.setState({ commentaireBAT:  newComment });
  }

  clearCommentaireBAT = () => {
    this.setState({ commentaireBAT:  null });
  }

  _isFabAvailable = () => {
    if (this.state.order.MarquageClair && this.state.operateur?.role
      && this.state.operateur.role != '22' && this.state.operateur.role != '34' && this.state.order.sav != '1') {
      return;
    }
    const droits = document.getElementById('formDroits');
    if (this.state.canValidate) {
      const formDroitsModal = document.getElementById('formDroitsModal');
      if(this.state.checkbox == '0' && droits && !this.state.showAlert) {
        droits.classList.add('alert', 'alert-danger', 'pl-3','pr-3');
      }
      if(this.state.checkbox == '0' && formDroitsModal  ) {
        formDroitsModal.classList.add('alert', 'alert-danger');
      }

      let blocsSansStatut = document.getElementsByClassName('needValidationBatAuto');

      if(blocsSansStatut.length === 0) {
        blocsSansStatut = document.getElementsByClassName('needReplaceBadQualityImg');
      }

      if(blocsSansStatut.length === 0) {
        blocsSansStatut = document.getElementsByClassName('nonConformeBloc');
      }

      if(blocsSansStatut.length > 0 && this.state.isBatAuto) {
        blocsSansStatut[0].classList.add('border-danger-bat-auto');
        if(blocsSansStatut[0].id) {
          this.setState({
            textAlert: 'Vous devez valider le BAT de chaque ligne avant de pouvoir poursuivre',
            classAlert: 'alert-danger',
            showAlert: true,
          }, () => {scrollTo(blocsSansStatut[0].id); });
        }
      } else {
        if (this.state.checkbox == '1') {
          if (droits) { droits.classList.remove('alert', 'alert-danger'); }
          if (formDroitsModal) { formDroitsModal.classList.remove('alert', 'alert-danger'); }
          this._resetAlert();
          this.onOpenModal();
        }
      }
    } else {
      if (droits) { droits.classList.remove('alert', 'alert-danger'); }
      this.setState({
        textAlert: 'Vous devez fournir tous les fichiers nécessaires avant de lancer la fabrication',
        classAlert: 'alert-danger',
        showAlert: true,
      });
    }
  }

  _uploadInProgress = () => {
    let blocsSansStatut = document.getElementsByClassName('needValidationBatAuto');

    if(blocsSansStatut.length === 0) {
      blocsSansStatut = document.getElementsByClassName('needReplaceBadQualityImg');
    }

    if(blocsSansStatut.length === 0) {
      blocsSansStatut = document.getElementsByClassName('nonConformeBloc');
    }
      
    if(blocsSansStatut.length === 0) {
      blocsSansStatut = document.getElementsByClassName('loaderBatAuto display-flex');
    }

    return blocsSansStatut.length > 0 && this.state.isBatAuto;
  }

  onOpenModal = () => { this.setState({ open: true }); }

  onCloseModal = () => { this.setState({ open: false }); }

  onCloseModalComment = () => { this.setState({ openComment: false, checkboxComment: '0' }); }

  onCloseModalPanachage = () => { this.setState({ openPanachage: false, checkboxPanachage: '0' }); }

  onCloseModalDevaliderFichiers = () => { this.setState({ openDevaliderFichiers: false}); }
  onOpenModalDevaliderFichiers = () => { this.setState({ openDevaliderFichiers: true}); }

  onCloseModalDevaliderFichiersByClient = () => { this.setState({ openDevaliderFichiersByClient: false}); }
  onOpenModalDevaliderFichiersByClient = () => { this.setState({ openDevaliderFichiersByClient: true}); }

  onCloseModalLancerFab = () => { this.setState({ openModalLancerFabrication: false}); }

  onCloseModalNonConforme = () => { this.setState({ openNonConforme: false}); }
  onOpenModalNonConforme = () => { this.setState({ openNonConforme: true}); }

  showComment = (isModal: boolean = false) => {
    const div = isModal ? document.getElementById('commentaireClientFilesModal') : document.getElementById('commentaireClientFiles');
    if (div) {
      if(this.state.checkboxComment != '0' && this.state.commentaire.length > 0) {
        div.classList.add('commentaireClientFilesShow');
        //this.setState({ openComment: false });
      }
      else if (!div.classList.contains('commentaireClientFilesShow')) {
        div.classList.add('commentaireClientFilesShow');
        this.setState({ openComment: false });
      } else {
        div.classList.remove('commentaireClientFilesShow');
        this.onCloseModalComment();
      }
    }
  }

  showPanachage = () => {
    this.setState({ openPanachage: false,  selectPanachage: true, checkboxPanachage: '1'});
  }

  _onChangeCommentaire = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ commentaire: event.target.value });
  }

  _selectPanachage = () => {
    if (this.state.selectPanachage) { this.setState({ selectPanachage: false }); }
    else { this.setState({ selectPanachage: true }); }
  }

  _showMoreOptions = () => {
    this.setState({ showMoreOptions: !this.state.showMoreOptions });
  }

  _defineOpacValidatationButton = (forceDisabled : boolean = false) => {
    if (!this.state.canValidate || forceDisabled ) { return 'opac30'; }
    return 'cursor-pointer';
  }

  _affectCanGallerie = () => {
    this._canGallerie();
  }

  _canGallerie = () => {
    axios.get(getHostApi() + '/shops/features/compte_upload_galerie',
      getRequestConfig(),
    ).then((response) => {
      this.setState({ canGallerie: response.data.feature });
    }).catch((error) => {
      console.log(error);
      if (error.response.status === 401) { sessionExpire(); }
    });
  }

  _fetchVariableMontantSansControleBATAuto = () => {
    axios.get(getHostApi() + '/shops/variables/batauto_montant_cmd_sans_controle',
      getRequestConfig(),
    ).then((response) => {
      if (response.data.variable) {
        this.setState({ montantBatAutoSansControle: response.data.variable['valeur'] });
      }
    }).catch((error) => {
      console.log(error);
      if (error.response.status === 401) { sessionExpire(); }
    });
  }

  _fetchBroderieIsComplete = () => {
    return axios
      .get(getHostApi() + '/customers/' + getUserId() + '/orders/' + this.state.selectedOrderId + '/embroidery-complete',
      getRequestConfig(),
      ).then((response) => {
        return response.data
      }).catch((error) => {
        if (error.response.status === 401) { sessionExpire(); }
      });
  }

  _needBat = () => {
    return this.state.order && !this.state.isBatAuto &&  this.state.order.confirmationFichier == '1' && this.state.order.validation_bat == '0' &&
    this.state.order.StatutCommande != '9' && this.state.order.StatutCommande != '8' && !this.state.order.MarquageClair && getShopInfosInStorage().Ref != 'DT';
  }

  _needBatAfterBatAuto = () => {
    return  this.state.order && this.state.order.confirmationFichier == '1' && this.state.order.validation_bat == '0' &&
      this.state.order.StatutCommande != '9' && this.state.order.StatutCommande != '8' && this.state.isBatAuto;
  }

  _defineClassEtape = () => {
    let classActive = 'fileEtape';
    if(this.state.isBatAuto) {
      if((this.state.order.validation_bat == '0' && this.state.order.confirmationFichier == '0') || (this._needBatAfterBatAuto() && !this.state.allVisuelsValide)) {
        classActive += '1';
      } else {
        classActive += '2';
      }
    } else {
      if (this.state.order.validation_bat == '0' && this.state.order.confirmationFichier == '0') {
        classActive += '1';
      } else if (this.state.order.validation_bat == '0' && this.state.order.confirmationFichier == '1') {
        classActive += '2';
      } else if (this.state.order.validation_bat == '1' && this.state.order.confirmationFichier == '1') {
        classActive += '3';
      } else if (this.state.order.validation_bat == '2') {
        classActive += '4';
      }
    }
    return classActive + 'Active';
  }

  _onUpdateDateLivraisonPrevue = (dateLivraison: string) => {
    this.setState({
      order:{
        ...this.state.order,
        date_livraison_prevue: dateLivraison,
      },
    });
  }

  _setValidationBATAuto = (isNotification: boolean = false) => {
    let broderieIsComplete = false;
    if(!this.state.isBatAutoBroderie) {
      this._confirmValidationBat(isNotification);
    } else {
      this._fetchBroderieIsComplete().then(response => {
        broderieIsComplete = response;
        if(!response) {
          alert("Toutes les broderies de la commande n'ont pas été validées");
          return false;
        }
      }).finally(() => {
        if(!broderieIsComplete) {
          return false;
        }
        this._confirmValidationBat(isNotification);
      });
    }
  }

  _confirmValidationBat = (isNotification: boolean = false) => {
    let commentaireBAT = null;
    if (this.state.setValidationBatAutoClicked || !this.state.isInternalUser) {
      return;
    }
    if(this.state.isInternalUserAdmin && !this.state.allVisuelsValide && isNotification) {
      if(!confirm('L\'envoi d\'un BAT impose que tous les visuels soient validés. Vous prenez la responsabilité de l\'impact de votre action sur le système. Souhaitez vous poursuivre et envoyer le BAT au client ?')) {
        return false;
      }
    }  else if(!isNotification) {
      const notOk = this.state.isInternalUser && !this.state.allVisuelsValideOperator;
      const confirmPhrase = notOk ? 'Avez-vous bien vérifié que tout est conforme ? cette action est irréversible. Souhaitez-vous poursuivre ?' : 'ATTENTION : Souhaitez vous Imprimer le BAT sans envoyer de BAT au client ?';
      if(!confirm(confirmPhrase)) {
        return false;
      }
    } else if(isNotification && this.state.isInternalUser && this.state.isBatAuto && this.state.commentaireBAT !== null) {
      commentaireBAT = this.state.commentaireBAT;
    }
    this.setState({setValidationBatAutoClicked: true });
    axios.post(`${getHostApi()}/customers/${getUserId()}/orders/${this.state.selectedOrderId}/bat-auto`, {isNotification: isNotification, commentaireBAT: commentaireBAT}, getRequestConfig())
        .then((response) => {
          this.setState({
            messageBat: response.data.message,
            successBAT: response.data.success
          });
        }).catch((error) => {
      if (error.response.status === 401) { sessionExpire(); }
    }).finally(() => {
      if(this.state.successBAT) {
        this.setState({ displayMessageBatAutoOK: true });
      } else {
        this.setState({
          textAlert: this.state.successBAT,
          classAlert: 'alert-danger',
          showAlert: true,
        });
      }
    });
  }

  _notifierNonConforme = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const dataNonConforme = this.state.dataNonConforme;
    axios.post(`${getHostApi()}/customers/${getUserId()}/orders/${this.state.selectedOrderId}/non-conforme`, {dataNonConforme: dataNonConforme}, getRequestConfig())
      .then(() => {
        this.onCloseModalNonConforme();
        this._getOrder();
        this.setState({
          showAlert: true,
          textAlert: 'Fichier(s) signalé(s) non conforme',
          classAlert: 'alert-success',
        });
      }).catch(() => {
      this.setState({
        showAlert: true,
        textAlert: 'Une erreur est survenue pendant la dévalidation des fichiers',
        classAlert: 'alert-danger',
        openDevaliderFichiers: false,
      });
    });
  }

  handleChangeRowValidationVisuelChecked = (array: validationVisuel) => {
    const [caddiesId] = array.id.split('-');
    const surfaceId = array.surfaceId;
    const emplacementId = array.emplacementId;
    const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.state.selectedOrderId}/statut-visuel`;
    const lstCaddies: string[] = [];
    let creationId = "";

    for (const element of this.state.order.panier) {
      if(element.idCaddies == caddiesId) {
        creationId = element.creation_id;
      }
      if(creationId == element.creation_id) {
        lstCaddies.push(element.idCaddies)
      }
    }
    axios.put(url, {statutVisuel: array.value, caddiesId: caddiesId, surfaceId: surfaceId, emplacementId: emplacementId, galerieFichierId: array.galerieFichierId, lstCaddies: lstCaddies}, getRequestConfig())
      .then((response) => {
        this._fetchStatutVisuels(true);
      }).catch((error) => { console.log(error); });
  }

  _handleChangeCustomerView = (customerView: boolean) => {
    if(customerView !== this.state.customerView) {
      this.setState({customerView: customerView});
    }
  }

  setStateByKeyValue(key: any, value: any){
    this.setState({[key] : value});
  }

  _fetchStatutVisuels = (changementStatut: boolean = false) => {
    const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.state.selectedOrderId}/statut-visuel`;
    axios.get(url, getRequestConfig())
      .then((response) => {
        this.setState({
          allVisuelsValide: response.data.valid, notSet: response.data.notSet, allVisuelsValideOperator: response.data.validOperator, needSendBat: response.data.needSendBat, visuelsIsEmpty: response.data.data.length === 0
        });

        if(this.state.canValidate && this.state.order.confirmationFichier == '0') {
          new Promise(resolve => setTimeout(resolve, 1000)).then(() => {
            const blocsSansStatut = document.getElementsByClassName('needValidationBatAuto');
            const blocsSansStatut2 = document.getElementsByClassName('needReplaceBadQualityImg');
            const lancerFab = document.getElementById("lancerFab");
            const formDroits = document.getElementById("formDroits");
            if(blocsSansStatut.length < 1 && blocsSansStatut2.length < 1 && lancerFab) {
              scrollTo("lancerFab");
              this.setState({
                needToValidate: true
              });
              if(formDroits && this.state.checkbox  === '0') { formDroits.classList.add('alert', 'alert-danger', 'pl-3', 'pr-3'); }
              if(changementStatut) {
                this.setState({
                  openModalLancerFabrication: true
                });
              }
            }
          });
        } else if(!this.state.canValidate && this.state.order && this.state.order.confirmationFichier == '0' && this.state.needToValidate) {
          this.setState({
            needToValidate: false
          });
        }
      }).catch((error) => { console.log(error); });
  }

  handleChangeNonConformeChecked = (array: conformiteVisuel) => {
    const key = array.id + "-" + array.galerieFichierId;
    const dataNonConforme = this.state.dataNonConforme;
    let aucunNonConforme = true;
    dataNonConforme[0] = {...dataNonConforme[0], [key]: array.value};

    for (const [key, value] of Object.entries(dataNonConforme[0])) {
      if(key && value) {
        aucunNonConforme = false
      }
    }

    this.setState({
      dataNonConforme: dataNonConforme,
      aucunNonConforme: aucunNonConforme
    });
  }

  render() {
    if (this._isMounted) {
    const needBAT = this._needBat();
    const needBATAfterBatAuto = this._needBatAfterBatAuto();

    const renderConfirmModalButtons = () => {
      return (
        <div className="mt-4 d-flex align-items-center justify-content-around">
          <button title="Annuler" onClick={this.onCloseModal}
                  className="border border-dark bold bg-white cursor-pointer btnCancelModal float-left py-2 px-3">
            <Icons icon="cancel" size={30} color="black" className="mr-2"/> Annuler
          </button>
          <button title="Valider" onClick={e => this._lancerFabrication(e)}
                  className={`border border-dark bold bg-white ml-0 ml-md-5 cursor-pointer btnValidateModal float-right py-2 px-3 `}>
            <Icons icon="check_circle" size={30} color="black" className="mr-2"/> Confirmer
          </button>
        </div>
      );
    };

    const renderContentConfirmModal = () => {
      const demandeTraitementOperateur = this.state.isBatAuto && !this.state.allVisuelsValide && !this.state.isBatAutoBroderie ? "Vous avez demandé l'intervention d'un opérateur pour vos fichiers. Cette opération peut ralentir votre commande." : null;
      let BatAvantFab =  this.state.isBatAuto ?  false : true;
      if(this.state.isBatAuto && this.state.needSendBat) {
        BatAvantFab = true;
      }
      let msgBat: JSX.Element | string = '';
      if (BatAvantFab) {
        if(this.state.order.StatutCommande && parseInt(this.state.order.StatutCommande) < 5) {
          msgBat = <span>Une fois votre commande payée, un Bon à Tirer (BAT) vous sera soumis pour validation<br/> avant la fabrication de votre commande.</span>;
        } else {
          msgBat = <span>un Bon à Tirer (BAT) vous sera soumis pour validation<br/> avant la fabrication de votre commande.</span>;
        }
      }
      return (
        <div className="d-flex align-items-center justify-content-center w-100 my-5 contentModal">
          <div className="ml-3">
            <p className="bold text-center">
              <Icons icon="warning" size={30} color="check" className="mr-2"/>
              Attention, après confirmation, vous ne pourrez ni ajouter ni supprimer de fichiers. </p>
            {demandeTraitementOperateur && <p className="text-center bold">{demandeTraitementOperateur}</p>}
            <p className="m-0 text-center">
              Voulez-vous confirmer l'envoi de vos fichiers à notre service de fabrication ?
              {BatAvantFab && (
                <div className="italic grey pt-2">{msgBat}</div>
              )}
            </p>
          </div>
        </div>
      );
    };

    /**
     * Rendu de la modal de confirmation
     *
     * @returns {any}
     */
    const renderConfirmModal = () => {
      return (
        <Modal open={this.state.open} onClose={this.onCloseModal} center
               classNames={{
                 overlay: 'bootstrap-container',
                 modal: 'confirmSendFilesModalContainer customModal',
                 closeButton: 'confirmSendFilesModalCloseButton closeButton'
               }}>
          <div className="modalOrder p-2 pa0Mobile" style={{maxHeight: '760px'}}>
            <div>
              <div className="bold border-bottom border-dark">
                Confirmation de l'envoi de vos fichiers
              </div>
              {renderContentConfirmModal()}
            </div>
            {renderConfirmModalButtons()}
          </div>
        </Modal>
      );
    };

    const renderCommentModalButtons = (isModal: boolean = false) => {
      return (
        <div className="mt-4 d-flex align-items-center justify-content-around">
          <button title="Annuler" onClick={this.onCloseModalComment}
                  className={'border border-dark bold bg-white cursor-pointer btnCancelModal float-left py-2 px-3' +
                    ' d-flex align-items-center'}>
            <Icons icon="cancel" size={30} color="black" className="mr-2"/> Annuler
          </button>
          <button title="Valider" onClick={e => this.showComment(isModal)}
                  className={'border border-dark bold bg-white ml-5 cursor-pointer btnValidateModal float-right' +
                    ' py-2 px-3 d-flex align-items-center'}>
            <Icons icon="check_circle" size={30} color="black" className="mr-2"/> Confirmer
          </button>
        </div>
      );
    };

    const renderPanachageModalButtons = () => {
      return (
        <div className="mt-4 d-flex align-items-center justify-content-around">
          <button title="Annuler" onClick={this.onCloseModalPanachage}
                  className={'border border-dark bold bg-white cursor-pointer btnCancelModal float-left py-2 px-63' +
                    ' d-flex align-items-center'}>
            <Icons icon="cancel" size={30} color="black" className="mr-2"/> Annuler
          </button>
          <button title="Valider" onClick={e => this.showPanachage()}
                  className={'border border-dark bold bg-white ml-5 cursor-pointer btnValidateModal float-right' +
                    ' py-2 px-6 d-flex align-items-center'}>
            <Icons icon="check_circle" size={30} color="black" className="mr-2"/> Confirmer
          </button>
        </div>
      );
    };

    const renderContentCommentModal = () => {
      return (
        <div>
          <div className="d-flex align-items-center justify-content-center w-100 mb-5 contentModal">
            <div className="">
              <p className="bold">
                <Icons icon="warning" size={30} color="check" className="mr-2"/>
                Le délai de traitement d'un commentaire peut ralentir votre commande. </p>
              <p className="m-0 text-center">
                Etes-vous sûr de vouloir ajouter un commentaire de fabrication ? </p>
            </div>
          </div>
        </div>
      );
    };

    const renderContentPanachageModal = () => {
      return (
        <div>
          <div className="d-flex align-items-center justify-content-center w-100 my-5 contentModal">
            <div className="ml-3">
              <p className="bold d-flex">
                <Icons icon="warning" size={30} color="check" className="mr-2"/>
                <span>
                  L'envoi de fichiers multiples peut entrainer l'annulation de votre commande en cas de non-respect de
                  nos conditions générales de vente.
                </span>
              </p>
              <p className="m-0 text-center">Etes-vous sûr de vouloir activer le panachage ? </p>
            </div>
          </div>
        </div>
      );
    };

    /**
     * Rendu de la modal de confirmation des commentaires
     *
     * @returns {any}
     */
    const renderConfirmModalComment = (isModal: boolean = false) => {
      return (
        <Modal open={this.state.openComment} onClose={this.onCloseModalComment} center
               classNames={{
                 overlay: 'bootstrap-container',
                 modal: 'confirmCommentModalContainer customModal',
                 closeButton: 'confirmCommentModalCloseButton closeButton'
               }}>
          <div className="modalOrder p-2 pa0Mobile" style={{maxHeight: '760px'}}>
            {renderContentCommentModal()}
            {renderCommentModalButtons(isModal)}
          </div>
        </Modal>
      );
    };

    /**
     * Rendu de la modal de confirmation d'activation du panachage
     *
     * @returns {any}
     */
    const renderConfirmModalPanachage = () => {
      return (
        <Modal open={this.state.openPanachage} onClose={this.onCloseModalPanachage} center
               classNames={{
                 overlay: 'bootstrap-container',
                 modal: 'confirmationPanachageModalContainer customModal',
                 closeButton: 'confirmationPanachageModalCloseButton closeButton'
               }}>
          <div className="modalOrder p-2 pa0Mobile" style={{maxHeight: '760px'}}>
            {renderContentPanachageModal()}
            {renderPanachageModalButtons()}
          </div>
        </Modal>
      );
    };

    const renderOptionsSelectOrders = () => {
      const options = [];
      if (this.state.orders) {
        for (const order of this.state.orders) {
          if (order.cf != '1' && !order.AucunMarquage && moment(order.DateDeCommande) >= moment(order.last2Years)) {
            options.push(
              <option value={order.idCommande} key={order.idCommande}>
                Commande {formatNumCommande(order.numCommande)} du {formatDate(order.DateDeCommande.split(' ')[0])}
              </option>,
            );
          }
        }
      }

      return options;
    };

    const renderSelectOrders = () => {
      if (this.state.orders && this.state.selectedOrderId) {
        return (
          <div>
            <select onChange={e => this._onChangeOrderSelected(e)} defaultValue={this.state.selectedOrderId}>
              {renderOptionsSelectOrders()}
            </select>
          </div>
        );
      }
    };

    const renderSelectCancelOrder = () => {
      if (this.state.orders && this.state.selectedOrderId) {
        return (
          <div>
            <select disabled defaultValue={this.state.selectedOrderId}>
              <option value={this.state.order.idCommande} key={this.state.order.idCommande}>
                Commande {formatNumCommande(this.state.order.numCommande)} du {formatDate(this.state.order.DateDeCommande.split(' ')[0])} - Commande annulée
              </option>
            </select>
          </div>
        );
      }
    };

    const renderActivatePanachageGlobalButton = () => {
      const showPanach = this.state.showMoreOptions && this.state.activatePanachage && this.state.showActivatePanachage;
      if(this.state.order.confirmationFichier == '0') {
        return (
          <>
            <div>
            <span style={this.state.showMoreOptions ? {border: '1px solid #eee', background: '#f9f9f9', borderRadius: '2px'} : {border: '1px solid transparent'}} className={`px-2 py-1 border-bottom-0 hoverUnderline cursor-pointer d-inline-block `} id={'moreOptions'}
                 onClick={this._showMoreOptions}>
              {this.state.showMoreOptions ? "- d'options" : "+ d'options"}
            </span>
            </div>
            <div style={this.state.showMoreOptions ? {border: '1px solid #eee', background : '#f9f9f9'} : {}} className={`${this.state.showMoreOptions ? 'shadow' : '' } d-flex flex-column  btnPanachageGlobal flex-grow-1`}>
              <div id="btnPanachageGlobal" className={`p-3 p3 pt-0 pl-2 ${!showPanach ? ' d-none ' : ' d-flex '}`}>
                <div className="text-center d-flex align-items-start activatePanachage">
                  <div className="d-flex align-items-center">
                    {renderInput('checkbox', 'activatePanachage', this.state.checkboxPanachage,
                      e => this._onUpdateInput(e), 'd-flex checkboxCommentaireUpload')}
                    <label data-tip data-for="explainPanachage" htmlFor="activatePanachage"
                           className="m-0 nobold flex-grow-1">
                      Activer le panachage
                    </label>
                  </div>
                </div>
              </div>
              {this.state.isBatAuto && !this.state.allVisuelsValide && !this.state.notSet && !this.state.visuelsIsEmpty && <div id="btnCommentaireGlobal"
                   className={`p-3 pt-0 pl-2 ${!this.state.showMoreOptions ? ' d-none ' : ' d-flex '}`}>
                {renderCommentaire()}
              </div>}
              {!this.state.selectPanachage &&
                <ReactTooltip id="explainPanachage" type="dark">
                  <div style={{maxWidth: '300px'}}>
                    Le panachage vous permet d'importer des visuels différents par article.
                  </div>
                </ReactTooltip>
              }
            </div>
          </>
        );
      }
    };

    const renderShowTelAssistance = () => {
      if (this.state.showTelephoneProblemeTechnique && this.state.order && this.state.telephoneProblemeTechique != ''
        && this.state.order.confirmationFichier == '0') {
        let formatPhone = this.state.telephoneProblemeTechique;
        if (formatPhone.length === 10) {
          formatPhone = formatPhone.substring(0, 2) + ' ' + formatPhone.substring(2, 4) + ' ' +
            formatPhone.substring(4, 6) + ' ' + formatPhone.substring(6, 8) + ' ' + formatPhone.substring(8, 10);
        }
        return (
          <div className="telAssistance alert alert-info font12 ml-4 mb-0 text-center p-2 flex-grow-1"
               style={{maxWidth: '250px'}}>
            Vous rencontrez un problème technique ? <span className="bold"> Contactez-nous au {formatPhone}</span>
          </div>
        );
      }
    };

    const renderSelectAndButton = () => {
      return (
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
          <div className="d-flex align-items-center flex-wrap">
            {this.state.order && this.state.order.StatutCommande == '9' && (this.state.isInternalUser && !this.state.customerView) ?
              renderSelectCancelOrder() : renderSelectOrders()}
          </div>
          {this.state.order && <div id="numCmd" className="d-none">{formatNumCommande(this.state.order.numCommande)}</div>}
          {renderShowTelAssistance()}
        </div>
      );
    };

    const renderOneStep = (number: string, textePrincipal: string, texteSecondaire: string, texteSecondaire2: string = '') => {
      return (
        <div className="d-flex align-items-center">
          <div className={'bold fileEtape fileEtape' + number + ' ' + this._defineClassEtape()}>
            <span className={'rondEtapes'} style={{background: getBoutiqueColor()}}>{number}</span>
            {textePrincipal}
            <span className="grey d-block small">{texteSecondaire}</span>
            {texteSecondaire2 !== '' &&
              <div className="grey d-block small">{texteSecondaire2}</div>
            }
          </div>
          <div className="iconesEtapes">
            <Icons icon="keyboard_arrow_right" size={30}/>
          </div>
        </div>
      );
    };

    const renderEtapesFichiers = () => {
      const refShopInfo = getShopInfosInStorage();
      if (this.state.order && this.state.order.validation_bat && this.state.order.StatutCommande && refShopInfo && refShopInfo.Ref && refShopInfo.Ref != 'DT') {
        if (this.state.orders && this.state.selectedOrderId && this.state.order.StatutCommande != '9' &&
          this.state.order.StatutCommande != '8' && !this.state.order.MarquageClair && !this.state.order.AucunMarquage && (!this.state.isBatAuto || (this.state.isBatAuto && this.state.isBatAutoBroderie && !this.state.customerChoixBroderie))) {
          return (
            <div className="etapesUpload text-center d-flex align-items-center justify-content-between ">
              {renderOneStep('1', 'Envoi des fichiers', '(' + this.state.authorizedFiles.join((', ')) + ')')}
              {renderOneStep('2', 'Création du BAT', 'par notre service de production')}
              {renderOneStep('3', 'Validation du BAT', 'notifié par e-mail et par sms')}
              {renderOneStep('4', 'Mise en fabrication', 'de votre commande')}
            </div>
          );
        } else if (this.state.isBatAuto) {
          const msgEtape = `(${this.state.authorizedFiles.join((', '))})`;
          const msgEtape2 = 'Validez directement vos BAT ou demandez le traitement par un opérateur ';
          return (
            <div className="etapesUpload text-center d-flex align-items-center justify-content-between ">
              {renderOneStep('1', 'Envoi des fichiers puis validation du BAT', msgEtape, msgEtape2)}
              {renderOneStep('2', 'Mise en fabrication', 'de votre commande')}
            </div>
          );
        }
      }
    };

    const renderFile = () => {
      const refShopInfo = getShopInfosInStorage();
      if (this.state.order && ((this.state.order.confirmationFichier == '0' || this.state.order.new_upload)) || (this.state.isBatAuto && refShopInfo.Ref === 'DT' && this.state.isInternalUser)) {
        return (
          <div className="my-4" onClick={() => { this._resetAlert(); }}>
            <RenderContentFiles
              key={this.state.selectedOrderId}
              orderId={this.state.selectedOrderId}
              order={this.state.order}
              onOrderUpdated={this._onOrderUpdated}
              nbPanachages={this.state.nbPanachages}
              activatePanachage={this.state.activatePanachage}
              activatePanachageQuadriluxe={this.state.activatePanachageQuadriluxe}
              activatePanachageTopQuadri={this.state.activatePanachageTopQuadri}
              activatePanachageSublimation={this.state.activatePanachageSublimation}
              activatePanachageSericoat={this.state.activatePanachageSericoat}
              activatePanachageBroderie={this.state.activatePanachageBroderie}
              activateCheckImageUsage={this.state.activateCheckImageUsage}
              selectPanachage={this.state.selectPanachage}
              onCanValidate={this._onCanValidate}
              canGallerie={this.state.canGallerie}
              marquages={this.state.marquages}
              canCustomDimensionsBatAuto={this.state.canCustomDimensionsBatAuto}
              hasClientFiles={this.state.hasClientFiles}
              activateBatAuto={this.state.isBatAuto}
              isBatAutoBroderie={this.state.isBatAutoBroderie}
              contourCustom={this.state.contourCustom}
              customerChoixBroderie={this.state.customerChoixBroderie}
              isInternalUser={this.state.isInternalUser}
              isInternalUserAdmin={this.state.isInternalUserAdmin}
              canUpdateFichierDestructure={this.state.canUpdateFichierDestructure}
              canUploadFichierDT={this.state.canUploadFichierDT}
              canUpdateCmjn={this.state.canUpdateCmjn}
              canDownloadEmbroidery={this.state.canDownloadEmbroidery}
              canCheckImageUsage={this.state.canCheckImageUsage}
              canUpdateOutlineProcessing={this.state.canUpdateOutlineProcessing}
              customerView={this.state.customerView}
              handleChangeRowValidationVisuelChecked={this.handleChangeRowValidationVisuelChecked}
              handleChangeNonConformeChecked={this.handleChangeNonConformeChecked}
              enabledPostProcessing={this.state.enabledPostProcessing}
            />
          </div>
        );
      }
    };

    const renderCustomerComment = () => {
      const logClient = this.state.order.logs.filter((log: any) => log.commentaire_client_child_tag_id == '30')
        .sort((a: any, b: any) => new Date(b.DateHeure).getTime() - new Date(a.DateHeure).getTime());
      if (getShopInfosInStorage().Ref != 'DT') {
        return (
          <div className="mt-5">
            <label className="bold text-underline">Votre commentaire :</label>
            <p>
              "{logClient[0]?.Commentaire ?? this.state.order.Commentaires}" </p>
          </div>
        );
      }
    };



    const renderEmptyComment = (isModal: boolean = false) => {
      const caracteresRestant = 140 - this.state.commentaire.length;
      let classAlert = '';

      if (caracteresRestant === 0) {
        classAlert = 'red';
      }
      const canWriteComment =  this.state.order.confirmationFichier == '0' && getShopInfosInStorage().Ref != 'DT' && (this.state.isBatAuto  && (!this.state.isBatAutoBroderie || !this.state.allVisuelsValide) && !this.state.notSet);

      if (canWriteComment) {
        return (
          <div className="text-center d-flex align-items-start flex-column commentaireUpload w-100">
            <div className={` d-flex align-items-center ${isModal ? 'pt-2' : '' } `}>
              {renderInput('checkbox', isModal ? "commentModal" : "comment", this.state.checkboxComment, e => this._onUpdateInput(e, isModal),
                'd-flex checkboxCommentaireUpload')}
              <label htmlFor={isModal ? "commentModal" : "comment"} className={` m-0 nobold ${isModal ? 'font14' : '' } `}>Ajouter un commentaire (facultatif)</label>
            </div>
            <div id={isModal ? "commentaireClientFilesModal" : "commentaireClientFiles"} style={{alignSelf: 'normal'}} className={`${this.state.commentaire.length > 0 &&  this.state.checkboxComment != '0'  ? 'commentaireClientFilesShow' : ''} commentaireClientFiles flex-grow-1 ml-3 mr-3 mt-1`}>
                <textarea id={isModal ? "commentaireClientModal" : "commentaireClient"} className="w-100 border border-dark p-2" rows={2} maxLength={140}
                          placeholder={'Attention : Tout commentaire ne concernant pas le traitement de vos fichiers' +
                            ' ne sera pas pris en considération.'} value={this.state.commentaire}
                          onChange={e => this._onChangeCommentaire(e)}>
                </textarea>
              <div>
                <p className={'text-right grey pt-2 ' + classAlert}>Caractères restants : {caracteresRestant}/140</p>
              </div>
            </div>
          </div>
        );
      }
    };

    const renderCommentaire = (isModal: boolean = false) => {
      if (this.state.order.confirmationFichier == '1' && this.state.order.Commentaires !== '') {
        return renderCustomerComment();
      } else {
        return renderEmptyComment(isModal);
      }
    };

    const renderDroits = (isModal: boolean = false) => {
      const classOpaq = !this.state.canValidate ? 'opac60' : '' ;
      if (this.state.order.confirmationFichier == '0') {
        return (
          <div id={isModal ? "formDroitsModal" : "formDroits"} className={`d-flex align-items-baseline justify-self-center pt-3 pb-3 pl-0 pb-0 text-justify cursor-pointer ${classOpaq} font14`} style={{margin: '0 auto'}} >
            <div>
              {renderInput('checkbox', 'droits', this.state.checkbox, e => this._onUpdateInput(e))}
            </div>
            <label htmlFor="droits" className={`m-0 cursor-pointer`}>
              Vous certifiez avoir les droits d'exploitation et d'auteurs des textes et images que vous fournissez. Vous
              dégagez ainsi la société Design'Partner de tout recours par les ayants droits éventuels.
            </label>
          </div>
        );
      }
    };

    const renderConfirmAlert = () => {
      return (
        <div className="w-100 text-center font-14">
          {renderAlert(this.state.showAlert, this.state.classAlert + ' justify-content-center',
            this.state.textAlert)}
        </div>
      );
    };

    const renderInfosPourClient = () => {
      return (
        <p className="legend mt-2 mb-4  italic grey text-center">
          Les visuels fournis sont redimensionn&eacute;s et plac&eacute;s automatiquement selon les
          caract&eacute;ristiques de votre commande. L&apos;emplacement et la dimension de vos visuels ne peuvent
          pas &ecirc;tre modifi&eacute;s. Les pictogrammes repr&eacute;sentant les articles sont non contractuels.
          Les couleurs des prévisualisations sont des couleurs &eacute;cran donn&eacute;es &agrave; titre
          indicatif, elles ne peuvent refl&eacute;ter les couleurs sur le textile marqu&eacute;. </p>
      );
    };

    const renderDateLivraisonEstimee = () => {
      const livraisonEstimee = moment(this.state.order.date_livraison_prevue !== '0000-00-00' ? this.state.order.date_livraison_prevue : this.state.order.DateSouhaite).locale('fr').format('dddd DD MMMM');
      return (
        <div className="mt-3 pb-3 text-normal">
          Temps restant pour une livraison estimée le <span className={'bold'}>{livraisonEstimee}</span></div>
      );
    };

    const renderValidationButton = (isModal: boolean = false) => {
      let texte: JSX.Element | string = 'Valider mes fichiers';
      let classe;
      let title;

      if (this.state.isBatAuto) {
        if (this.state.allVisuelsValide && (!this.state.isBatAutoBroderie || this.state.customerChoixBroderie)) {
          texte = 'Lancer la fabrication';
        } else {
          if ((this.state.canValidate && !this.state.notSet)) {
            texte = <span>Valider l'envoi des fichiers
              <span className={`noBold d-block font12 notifBatStr`}>Un BAT sera disponible prochainement dans <br/>votre espace client (notifié par email et sms)</span>
            </span>;
          } else {
            texte = 'Lancer la fabrication';
            title = 'Confirmez tous vos visuels';
            classe = '  cursor-not-allowed  ';
          }
        }
        if(this.state.needToValidate && this.state.checkbox == '0') {
          classe = ' white ';
        }
      } else if (this.state.order.MarquageClair) {
        texte = 'Lancer la fabrication';
        if (this.state.operateur?.role
          && this.state.operateur.role != '22' && this.state.operateur.role != '34' && this.state.order.sav != '1') {
          classe = 'white cursor-not-allowed opac30 ';
          title = 'Seul le client peut accepter un BAT';
        }
      }


      return (
        <>
          <div
            className={`text-uppercase bold font22 black mb-2 mt-3 d-flex align-items-center flex-column justify-content-center 
               ${this._defineOpacValidatationButton()}`} title={title}>
            <div className={`d-flex flex-column align-items-center   my-2
            justify-content-center ${isModal ? ' w-md-60 w100' : ' ' }`}>
              <div id="lancerFab"
                   className={` d-flex align-items-center justify-content-center bg-blue white cursor-pointer fabBtn lineheight1 buttonPrimary text-center py-3 px-4 w-100 ${classe} `}
                   onClick={this._isFabAvailable}>
                <Icons icon="settings" className="pr-2" size={30}/>
                <button className={`m-0 border-0 white bold font16 p-0 reset-button bg-transparent ${classe}`}>
                  {texte}
                </button>
              </div>
            </div>
          </div>
        </>
      );
    };
    const renderCommentairesFab = (onlyCustomerComment : boolean = false) => {
      const html: JSX.Element[] = [];
      if(this.state.commentairesFabrication) {
        this.state.commentairesFabrication.forEach((commentaire: any, index: number) => {
          if (!onlyCustomerComment || (onlyCustomerComment && commentaire.commentaire_client_child_tag_id == "30" && commentaire.commentaire_client_tag_id == "1")) {
            const dateLog = moment(commentaire.DateHeure).locale('fr').format('dddd DD MMMM HH:mm');
            html.push(
              <div className={`alert-warning ${onlyCustomerComment ? 'p-3' : 'pa05 mb05 '}`} key={index}>
                <span className={`mr-2 ${onlyCustomerComment ? 'd-none' : 'bold'} `}>{dateLog}</span>
                <span  className={` ${onlyCustomerComment ? 'bold italic font20 onlyCustomerComment' : ''}`} >{commentaire.Commentaire}</span>
                {onlyCustomerComment &&
                  <span  className={`ml-1 font20`}>(Client)</span>
                }
              </div>
            );
          }

        });
      }
      if(html && html.length > 0) {
        const strTitle = onlyCustomerComment ? 'Commentaires du client' : 'Traçabilité de la commande';

      return (
        <div className={``}>
          {!onlyCustomerComment &&
            <button className={'w-100  black border-0 bg-transparent justify-content-center cursor-pointer m-0  importButton d-flex align-items-center btnAfficherCommentaire'} id="btnAfficherCommentaire" onClick={() => {this.setStateByKeyValue('showTracabilite',!this.state.showTracabilite)}}>
              <Icons icon={!this.state.showTracabilite ? 'add_circle_outline' : 'remove_circle_outline'} className="pr-2" size={30}/>
              {strTitle}
            </button>
          }
          <div className={`${this.state.showTracabilite || onlyCustomerComment ? '' : 'd-none'}`}>
            <div className={`${onlyCustomerComment ? 'text-center ' : ''}`}>
          {html}
            </div>
          </div>
        </div>
        );
      } else {
        return null;
      }
    };

    const renderImprimerBatAutoButton = (texte: string = 'Imprimer', isAdmin: boolean = false) => {
      const notOk = false;
      return (
        <>
          <div
            className={` ${isAdmin ? ' ' : 'mt-3 text-uppercase bold font22 black mb-2 d-flex align-items-center flex-column justify-content-center'}  ${this._defineOpacValidatationButton(notOk)}`} >
            <div className={` ${isAdmin ? ' ' : 'd-flex flex-column align-items-center w-md-30 w100 my-4'} `}>
              <div id="imprimerBatAuto"
                   className={`  ${isAdmin ? '  ' : ' bg-blue white buttonPrimary py-3 d-flex align-items-center justify-content-center   w-100 fabBtn lineheight1  text-center'} ${notOk ? '  cursor-not-allowed ' : ' cursor-pointer '} `}
                   onClick={() => { notOk ? alert('Vous n\'avez pas contrôlé tous les fichiers du client ') :  this._setValidationBATAuto()   }}>
                <Icons icon="print" className="pr-2" size={isAdmin ? 25 : 30}/>
                <button className={`m-0 border-0 bold ${isAdmin ? 'font12' : 'white font16'} p-0 reset-button bg-transparent  ${notOk ? '  cursor-not-allowed ' : ' cursor-pointer'} `}>
                  {texte}
                </button>
              </div>
            </div>
          </div>
        </>
      );
    };

    const renderSignalerFichierBatAutoButton = (texte: string) => {
      return (
        <>
          <div
            className={'mt-3 text-uppercase bold font22 black mb-2 d-flex align-items-center flex-column justify-content-center '} >
            <div className="d-flex flex-column align-items-center w-md-30 w100 my-4
            justify-content-center">
              <div
                   className={` d-flex align-items-center justify-content-center bg-blue white fabBtn lineheight1 buttonPrimary text-center py-3 px-4 w-100 cursor-pointer`}
                   onClick={() => { this.onOpenModalNonConforme(); }}>
                <button className={`m-0 border-0 white bold font16 p-0 reset-button bg-transparent cursor-pointer`}>
                  {texte}
                </button>
              </div>
            </div>
          </div>
          {renderNonConformeModal()}
        </>
      );
    };

      const renderNonConformeModal = () => {
        return (
          <Modal open={this.state.openNonConforme} onClose={this.onCloseModalNonConforme} center
                 classNames={{overlay: 'bootstrap-container', modal: ' customModal',
                   closeButton: ' closeButton'}}>
            <div className="p-2">
              <p className={'text-center font18 bold'}>Attention, vous allez indiquer au client que certains de ses fichiers sont non conformes. Souhaitez-vous poursuivre ?</p>
              <button title="Annuler" onClick={this.onCloseModalNonConforme}
                      className="border border-dark bold bg-white cursor-pointer btnCancelModal  py-2 px-3 float-left">
                <Icons icon="cancel" size={30} color="black" className="mr-2"/> Annuler
              </button>
              <button title="Valider" onClick={this._notifierNonConforme}
                      className={'border border-dark bold bg-white ml-0 ml-md-5 cursor-pointer btnValidateModal py-2 px-3 float-right'}>
                <Icons icon="check_circle" size={30} color="black" className="mr-2"/> Confirmer
              </button>
            </div>
          </Modal>
        );
      };



    const renderConfirmSendBatModal = () => {
      return (
        <Modal open={this.state.openBAT} onClose={this.onCloseBAT} center
               classNames={{overlay: 'bootstrap-container',modal: ' customModal',
                 closeButton: ' closeButton'}}>
          <div className="p-2">
            <p className="text-center font18 bold">&Ecirc;tes-vous sûr de vouloir envoyer ce BAT ? <span className={'grey'}>le client sera notifié par Email et par SMS.</span></p>

            {this.state.commentaireBAT !== null &&
              <div className={'d-flex align-items-center my-4 justify-content-center flex-column'}>
              Vous avez écrit un commentaire avec ce BAT :
              <div className={"p-3 italic font18 w-100 text-center border my-2"}>" {this.state.commentaireBAT} "</div>
                <div className={'text-underline cursor-pointer'} title={'Supprimer ce commentaire'} onClick={this.clearCommentaireBAT}>Supprimer</div>
              </div>
            }

            <button title="Annuler" onClick={this.onCloseBAT}
                    className="border-0 bold bg-white cursor-pointer border-dark btnCancelModal float-left py-2 px-3">
              Non
            </button>
            <button title="Notifier le BAT" onClick={() => {this._setValidationBATAuto(true)}}
                    className="border-dark border bold bg-white cursor-pointer btnValidateModal float-right py-2 px-3">
              Oui
            </button>
          </div>
        </Modal>
      );
    };

    const renderNotificationBatAutoButton = () => {
      const texte = 'Envoyer le BAT au client';
      let classe;
      let style;
      const title: string | undefined = 'Tous les visuels doivent être validés avant de pouvoir envoyer le BAT au client';
      if (!this.state.allVisuelsValide) {
        classe = 'cursor-not-allowed ';
        style = {background: '#f2f2f2 !important', color: 'black'};
      }
      return (
        <div className={''}>
          <div className="d-flex justify-content-center mt-3 ">
            <div className="w-50 flex-grow-1 form-group mr-2  d-flex  flex-column justify-content-center  align-self-start border">
              <div className={'collapseCommentairesFab'}>
                {renderCommentairesFab()}
              </div>
            </div>
          <div className="w-50  flex-grow-1 form-group ml-2 d-flex  flex-column justify-content-center align-self-start border">
            <button className={'black border-0 bg-transparent justify-content-center cursor-pointer m-0  importButton d-flex align-items-center btnAfficherCommentaire'} id="btnAfficherCommentaire" onClick={() => {this.showCommentaireBAT()}}>
              <Icons icon={!this.state.showCommentaireBat ? 'add_circle_outline' : 'remove_circle_outline'} className="pr-2" style={style} size={30}/>
              Commentaire BAT
            </button>
            <div id="form-commentaire" className={'m-2'} hidden={!this.state.showCommentaireBat}>
              <textarea className="form-control w100 my-2 font16" placeholder="Saisissez ici votre commentaire lié au BAT (facultatif)" name="commentaire_bat" id="commentaire_bat"   onChange={e => this.setCommentaireBAT(e)} maxLength={255}>
                {this.state.commentaireBAT}
              </textarea>
            </div>
          </div>
          </div>
          <div
            className={'mt-3 text-uppercase flex-grow-1 bold font22  mb-2 d-flex align-items-center flex-column justify-content-center ' + classe +
              this._defineOpacValidatationButton()} title={title}>
            <div
              className={'d-flex flex-column align-items-center w-md-30 w100 my-4 justify-content-center ' + classe}>
              <div id="notifierBatAuto"  onClick={() => {
                (!this._uploadInProgress() && (this.state.allVisuelsValide || this.state.isInternalUserAdmin)) ? this.onOpenBAT() : alert('' + title + '')
              }} style={!this.state.allVisuelsValide ? {
                border: '1px solid black',
                background: '#f2f2f2',
                color: 'black'
              } : {}}
                   className={`d-flex align-items-center justify-content-center cursor-pointer fabBtn lineheight1 buttonPrimary text-center py-3 px-4 w-100 ${!this.state.allVisuelsValide ? ' opac30 ' : 'bg-blue white '} ${classe}`}
                   >
                <Icons icon="mail" className="pr-2" style={style} size={30}/>
                <button disabled={this._uploadInProgress() || !this.state.allVisuelsValide} style={!this.state.allVisuelsValide ? {
                  color: 'black'
                } : {color: 'white'}}
                        className={'m-0 border-0  bold font16 p-0 reset-button bg-transparent ' + classe}>
                  {texte}
                </button>
              </div>
            </div>
          </div>
          {renderConfirmSendBatModal()}
        </div>
      );
    };

    const renderValidationButtonAndInfosClient = (isModal: boolean = false) => {
      if (this.state.order.confirmationFichier == '0') {
        return (
          <div>
            {renderValidationButton(isModal)}
            {renderConfirmModal()}
            {renderConfirmModalComment(isModal)}
            {renderConfirmModalPanachage()}
          </div>
        );
      }
    };
    const renderTexteUploadOk = () => {
      let phraseBAT = '';
      const needValidateOldBat = this.state.isBatAuto && this.state.order.confirmationFichier == '1' && this.state.order.validation_bat == '1';
      const batIsValide = this.state.isBatAuto && this.state.order.validation_bat == '2';

      if (this.state.order.confirmationFichier == '1') {
        if (needBAT) {
          phraseBAT = 'Vous serez prochainement averti lorsque votre Bon à Tirer sera disponible.';
        } else if (needBATAfterBatAuto) {
          if (!this.state.allVisuelsValide) {
            if (this.state.order.StatutCommande && this.state.order.StatutCommande < 5) {
              phraseBAT = "Une fois votre commande payée, vous serez averti lorsque votre Bon à Tirer sera disponible."
            } else {
              phraseBAT = 'Vous serez prochainement averti lorsque votre Bon à Tirer sera disponible.';
            }
          }
        }
        if (batIsValide) {
          phraseBAT = phraseBAT + ' Votre BAT est validé.'
        }
        return (
          <div id="envoiFichierOK">
            <div
              className={`font14 bold text-center mt-3 border p-3 ${needValidateOldBat ? ' d-flex flex-wrap align-content-center justify-content-center py-2' : ''}`}>
              <div className={"align-self-center "}>
                <Icons icon="check_circle" size={20} color="green" className="mr-1"/>
                L'envoi de vos fichiers s'est correctement d&eacute;roul&eacute;. <br/>
                {phraseBAT}
              </div>
              {needValidateOldBat &&
                <div className={"p-2 p-lg-0 ml-2 mx-2 "}>
                  <a className="btnBatAuto d-block  text-center py-3 px-4 w-100 bg-blue  white"
                     href={'/www/MonCompte/moncompte.php/bat/' + this.state.order.idCommande}>Voir mon BAT</a>
                </div>
              }
            </div>
          </div>
        );
      }
    };

    const renderTexteBatAutoValide = () => {
      if (this.state.messageBat && this.state.successBAT) {
        const message = this.state.messageBat;
        return (
          <div id="envoiBatAutoOK">
            <p className="font14 bold text-center mt-3 border p-3">
              <Icons icon="check_circle" size={20} color="green" className="mr-1"/>
              {message}
            </p>
          </div>
        );
      }
    };

    const renderCancel = () => {
      return (
        <div>
          <p className="font16 bold mt-3 text-center">
            La commande {this.state.order.numCommande} a été annulée.<br/>
            Vous ne pouvez pas envoyer de fichiers pour cette commande. </p>
        </div>
      );
    };

    const renderDevaliderFichier = () => {
      const cmdPrincipale = this.state.cmdPrincipale ? this.state.cmdPrincipale.split('-')[2] : '';
      return (
        <>
          {cmdPrincipale && <p className={'my-2'}><span className={'bold pl-1'}>SAV : </span>Récupérer les fichiers de la commande initiale <a href={this.state.lienOldCmd} target={"_blank"} title={"Récupérer les fichiers de l'ancienne commande"}>{cmdPrincipale}</a></p>}
          <div onClick={() => { this.onOpenModalDevaliderFichiers(); }} className={' d-flex align-items-center justify-content-center  cursor-pointer'}>
          <Icons icon="ic-revert" className="pr-2" size={25}/>
            <button  className={`m-0 border-0 bold font12 p-0 reset-button bg-transparent   cursor-pointer   `}>
              Dévalider les fichiers
            </button>
          </div>
          {renderDevaliderFichierModal(cmdPrincipale)}
        </>
      )
    };

      const renderDevaliderFichierModal = (cmdPrincipale: string) => {
        return (
          <Modal open={this.state.openDevaliderFichiers} onClose={this.onCloseModalDevaliderFichiers} center
                 classNames={{overlay: 'bootstrap-container',modal: ' customModal',
                   closeButton: ' closeButton'}}>
            <div className="p-2">
              {cmdPrincipale.length > 0 ? <>
                <p className={'text-center font18 bold'}>Dévalider les fichiers (Commande initiale <a href={this.state.lienOldCmd} target={"_blank"} title={"Récupérer les fichiers de l'ancienne commande"}>{cmdPrincipale}</a>)</p>
                <p className={'text-center small italic'}>Ne pas oublier de récuperer les fichiers de la commande initiale</p></> :
                <p className={'text-center font18 bold'}>Dévalider les fichiers du client</p>
              }
              <button title="Annuler" onClick={this.onCloseModalDevaliderFichiers}
                      className="border border-dark bold bg-white cursor-pointer btnCancelModal  py-2 px-3 float-left">
                <Icons icon="cancel" size={30} color="black" className="mr-2"/> Annuler
              </button>
              <button title="Valider" onClick={(event) => { this._devaliderFichier(event); }}
                      className={'border border-dark bold bg-white ml-0 ml-md-5 cursor-pointer btnValidateModal py-2 px-3 float-right'}>
                <Icons icon="check_circle" size={30} color="black" className="mr-2"/> Confirmer
              </button>
            </div>
          </Modal>
        );
      };

      const modalToLancerFab = () => {
        return (
          <Modal open={this.state.openModalLancerFabrication} onClose={this.onCloseModalLancerFab} center
                 classNames={{overlay: 'bootstrap-container',modal: ' customModal',
                   closeButton: 'closeButton'}}>
            <div className="p-2">
              <p className={"text-uppercase bold font22 black text-center arial"}>Valider mes fichiers</p>
              {renderDroits(true)}
              {this.state.isBatAuto && !this.state.allVisuelsValide && renderCommentaire(true)}
              {renderValidationButtonAndInfosClient(true)}
            </div>
          </Modal>
        );
      };

      const renderOperatorBandeau = (condition: boolean) => {
        if((condition || (this.state.isInternalUser && this.state.isBatAuto))) {
          return (
            <div className={'interfaceOperateur d-flex justify-content-center'}>
              <span>Interface réservée aux opérateurs fichiers</span>
              <div className={"d-flex ml-4 justify-content-center align-items-center"}>
                <SwitchBtn value={this.state.customerView} onChangeEvent={this._handleChangeCustomerView}/>
                <div className={"ml-2"}> Vue Client</div>
              </div>
            </div>
          );
        }
      };

    const renderPage = () => {

      if (this.state.order) {
        const conditionsDisplayBtnBatAuto = (this.state.isInternalUser) && this.state.isBatAuto && this.state.order.confirmationFichier == 1 &&
          this.state.order.validation_bat == 0 && !this.state.setValidationBatAutoClicked && this.state.order.StatutCommande == '5';
        const needSendBat = conditionsDisplayBtnBatAuto && this.state.needSendBat;
        const needPrintWithoutBat = conditionsDisplayBtnBatAuto && !needSendBat;
        const printForceIsAdmin = conditionsDisplayBtnBatAuto && !needPrintWithoutBat && this.state.isInternalUserAdmin;
        const conditionsDisplayDevaliderBtn = (getShopInfosInStorage().Ref === 'DT' && this.state.order.sav == "1") || (getShopInfosInStorage().Ref != 'DT' && this.state.isInternalUser && this.state.isBatAuto && this.state.order.validation_bat == '0' && this.state.order.confirmationFichier == '1');

        if (this.state.order.StatutCommande == '9' && (!this.state.isInternalUser || this.state.customerView)) {
          return <>
            {renderOperatorBandeau(conditionsDisplayBtnBatAuto)}
            {renderCancel()}
          </>
        }
        return (
          <div>
            {renderTexteUploadOk()}
            {(this.state.commentairesFabrication && conditionsDisplayBtnBatAuto && !this.state.customerView && (needSendBat || needPrintWithoutBat || printForceIsAdmin)) &&
              <div className={'mt2'}>{renderCommentairesFab(true)}</div>
            }
            {renderFile()}
            {renderActivatePanachageGlobalButton()}
            {renderConfirmAlert()}
            {this.state.order.confirmationFichier == '0' &&
              <div
                className={'font14  d-flex flex-column text-normal nobold justify-content-center align-items-center'}>
                {isFichierAttenteValidation(
                    this.state.order.StatutCommande,
                    this.state.order.confirmationFichier) && this.state.order.infosCompteur &&
                  <>
                    {isFichierAttenteValidation(
                      this.state.order.StatutCommande,
                      this.state.order.confirmationFichier) && this.state.order.sav != '1' && renderDateLivraisonEstimee()}
                    {!this.state.order.AucunMarquage &&
                      <RenderCountdown type={'Fichier'} idCommande={this.state.order.idCommande}
                                       dateLivraisonPrevue={this.state.order.date_livraison_prevue !== '0000-00-00' ? this.state.order.date_livraison_prevue : this.state.order.DateSouhaite}
                                       infosCompteur={this.state.order.infosCompteur}
                                       onChangeDateLivraison={this._onUpdateDateLivraisonPrevue}/>}
                  </>
                }
              </div>
            }
            <div className={`${this.state.order.confirmationFichier == '0' ? 'mb-4' : ''}`} style={{border: "1px solid transparent", padding: this.state.order.confirmationFichier == '0' ? "15px 0 " : "0"}}>
              {renderDroits()}
              {renderValidationButtonAndInfosClient()}
            </div>
            <div className={'mx-2'}>
              {renderInfosPourClient()}
            </div>
            {this.state.order.confirmationFichier == '1' && this.state.order.StatutCommande < 5 &&
              <DevaliderFichiersClient _devaliderFichier={this._devaliderFichier} openDevaliderFichiersByClient={this.state.openDevaliderFichiersByClient}
                                       classAlert={this.state.classAlert} onCloseModalDevaliderFichiersByClient={this.onCloseModalDevaliderFichiersByClient}
                                       onOpenModalDevaliderFichiersByClient={this.onOpenModalDevaliderFichiersByClient}
                                       textDevaliderFichierByClient={this.state.textDevaliderFichierByClient}/>
            }
            {(conditionsDisplayBtnBatAuto && !this.state.customerView && (needSendBat || needPrintWithoutBat || printForceIsAdmin )) &&
              <div>
                {needSendBat && this.state.aucunNonConforme && ((this.state.order.sav == '1' && this.state.order.confirmationFichier == '1') || this.state.order.sav != '1')  && renderNotificationBatAutoButton()}
                {((needPrintWithoutBat && this.state.aucunNonConforme) || (this.state.cmdPrincipale && this.state.allVisuelsValideOperator && this.state.aucunNonConforme)) &&
                  <div>{renderImprimerBatAutoButton('Je valide pour impression')}</div>
                }
                {!this.state.aucunNonConforme &&
                  <div>{renderSignalerFichierBatAutoButton('Dévalider les fichiers et signaler des fichiers non conformes par email et SMS')}</div>
                }
                <div className={'d-flex justify-content-between align-items-center'}>
                {(this.state.cmdPrincipale || conditionsDisplayDevaliderBtn) && renderDevaliderFichier()}
                {(printForceIsAdmin && !this.state.cmdPrincipale && this.state.aucunNonConforme) &&
                  <div>{renderImprimerBatAutoButton('Forcer l\'impression (ADMIN - hors système)', true)}</div>
                }
                </div>
              </div>
            }
            {((this.state.isInternalUser && !this.state.customerView && this.state.isBatAuto && this.state.order.validation_bat == '2') ||
              this.state.displayMessageBatAutoOK) && renderTexteBatAutoValide()}
            {this.state.openModalLancerFabrication && modalToLancerFab()}
            {renderOperatorBandeau(conditionsDisplayBtnBatAuto)}
          </div>
        );
      }
      return (
        <p className="text-secondary border border-secondary p-2 text-center mt-5 rounded">
          Actuellement, aucune commande ne nécessite un envoi de fichiers.
        </p>
      );
    };

    return (
      <div>
        {renderTitleH1('file_upload', 'Envoi des fichiers')}
        {renderFilArianne('', 'Envoi des fichiers')}
        {renderSelectAndButton()}
        {renderEtapesFichiers()}
        {renderPage()}
      </div>
    );
  } else {
      return null;
    }
  }
}